var map = {
	"./": 62,
	"./constants": 102,
	"./constants.js": 102,
	"./currency": 103,
	"./currency.js": 103,
	"./event-bus": 104,
	"./event-bus.js": 104,
	"./get-color": 105,
	"./get-color.js": 105,
	"./index": 62,
	"./index.js": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;